module.exports = __webpack_public_path__ + "static/media/dikshachaudhary.479481c7.jpg";